/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import {
  RECEIVE_NOTE_BASKET_ALL_TAGS,
  RECEIVE_NOTE_FAST_TRACK_ALL_TAGS,
} from '../metadaWarehouseReceiveNote/tags';

export const getBasketCheckoutTags = (receiveNoteId: string) => [
  ...RECEIVE_NOTE_BASKET_ALL_TAGS(receiveNoteId),
  {type: 'receiveNoteState' as const, id: receiveNoteId},
  'receiveNoteTotalPrice' as const,
  'headerDynamicActions' as const,
  ...RECEIVE_NOTE_FAST_TRACK_ALL_TAGS(receiveNoteId),
  'deliveryNote' as const,
];

export const getDeleteBasketTags = (receiveNoteId: string) => [
  ...RECEIVE_NOTE_BASKET_ALL_TAGS(receiveNoteId),
  {type: 'receiveNoteState' as const, id: receiveNoteId},
  'receiveNoteTotalPrice' as const,
  'headerDynamicActions' as const,
];
